import { capitaliseFirstLetter } from "./Text";

export enum ContentType {
    List = 0,
    Page = 1,
    Rss = 2,
    Contact = 3,
    Web = 4,
    Image = 5,
    File = 6,
    Video = 7,
    NotAccepted = 8,
    Audio = 9,
    Form = 10,
    CombinedFeed = 11
}

export const getContentTypeString = (contentTypeNumber: number): string => {
    switch (contentTypeNumber) {
        case ContentType.List:
            return "list";
        case ContentType.Page:
            return "page";
        case ContentType.Rss:
            return "rss";
        case ContentType.Contact:
            return "contact";
        case ContentType.Web:
            return "web";
        case ContentType.Image:
            return "image";
        case ContentType.File:
            return "file";
        case ContentType.Video:
            return "video";
        case ContentType.NotAccepted:
            return "notAccepted";
        case ContentType.Audio:
            return "audio";
        case ContentType.Form:
            return "form";
        case ContentType.CombinedFeed:
            return "Combined Feed";
        default:
            return "unknown";
    }
};


export const getPlaceholderImage = (mediaType: number): string => {
    const contentTypeString = getContentTypeString(mediaType);
    
    if (['video', 'audio', 'list', 'contact', 'page', 'rss', 'file', 'image'].includes(contentTypeString)) {
        return `/Content/img/icons/types/${contentTypeString}_icon.svg`;
    } 
    else if (contentTypeString === 'web') {
        return `/Content/img/icons/types/html_icon.svg`;
    } 
    else if (contentTypeString === 'Combined Feed') {
        return `/Content/img/icons/types/combinedFeed_icon.svg`;
    } 
    
    return `/Content/img/icons/types/page_icon.svg`;
};

export const getPlaceholderIcon = (mediaType: string): string => {    
    if (['video', 'audio', 'list', 'contact', 'page', 'rss', 'file', 'image', 'combinedFeed'].includes(mediaType)) {
        return `/Content/img/icons/types/${mediaType}_icon.svg`;
    } 
    else if (mediaType === 'web') {
        return `/Content/img/icons/types/html_icon.svg`;
    } 
    
    return `/Content/img/icons/types/page_icon.svg`;
};

export const getPermissionString = (permission: string): string => {
    if (permission === "edit") {
        return 'Can Edit';
    } else if (permission === "partial") {
        return "Partial Edit"
    } else {
        return 'View Only';
    }
}


export function getContentTitleFromContentTitleInput() {
   let pageTitle = "default";
    
    const titleInput = document.querySelector<HTMLInputElement>("input#Title.editableText");
    if (titleInput) {
        if (titleInput.value.trim()) {
            pageTitle = titleInput.value.trim();
        } else if (titleInput.placeholder.trim()) {
            pageTitle = titleInput.placeholder.trim();
        }
    }

    return pageTitle;
}

export const contentUrlHref = (appGuid: string, contentId: string, parentId: string): string => {
    return `../a/${appGuid}/Content/Index/${contentId}?parentId=${parentId}`;
}

export const listContentUrlHref = (appGuid: string, contentId: string, parentId: string): string => {
    return `/a/${appGuid}/Content/Index/${contentId}?parentId=${parentId}`;
}

export const parentContentUrlHref = (appGuid: string, contentId: string): string => {
    return `../a/${appGuid}/Content/Index/${contentId}`;
}

export const getContentUrl = (appGuid: string, contentId: string, parentId?: string): string => {
    if (parentId) {
        return hasParentContentUrlHref(appGuid, contentId, parentId);
    } else {
        return noParentContentUrlHref(appGuid, contentId);
    }
}

export const hasParentContentUrlHref = (appGuid: string, contentId: string, parentId: string): string => {
    return `${window.location.origin}/a/${appGuid}/Content/Index/${contentId}?parentId=${parentId}`;
}

export const noParentContentUrlHref = (appGuid: string, contentId: string): string => {
    return `${window.location.origin}/a/${appGuid}/Content/Index/${contentId}`;
}

export const homeContentUrlHref = (appGuid: string, contentId: string): string => {
    return `${window.location.origin}/a/${appGuid}/Content/Index/${contentId}?homeLink=True`;
}

export const menuContentUrlHref = (appGuid: string): string => {
    return `${window.location.origin}/a/${appGuid}`;
}

export function getContentIdFromUrl(url: string): string | null {
    const parsedUrl = new URL(url);
    const parts = parsedUrl.pathname.split("/").filter(Boolean);
    const idx = parts.indexOf("Index");
    return idx !== -1 ? parts[idx + 1] : null;
}

export function getParentIdFromUrl(url: string) {
    const parsedUrl = new URL(url);
    const queryParams = Object.fromEntries(parsedUrl.searchParams.entries());
    const parentId = queryParams.parentId;

    return parentId ?? null;
};

export function currentPageIsAContentPage(url: string) {
    const parsedUrl = new URL(url);
    const pathParts = parsedUrl.pathname.split("/").filter(Boolean);
    const isContentPage = pathParts.includes("Content");

    return isContentPage
}

export function getPublishedStatus(status: any) {
    if(status === "draft") {
        return 'Draft'
    } else if (status === 'published') {
        return 'Published'
    } else if (status === 'publishedWithDraftChanges') {
        return 'Published with changes drafted'
    } else {
        return ""
    }
};


export const getTypeLabel = (type: string) => {
    if (type === 'combinedFeed') return 'Combined Feed'
    return capitaliseFirstLetter(type)
}